import { QA_SESSIONS } from '#client/pages/Education/data';

export function useQASession() {
  return {
    data: QA_SESSIONS,
    error: null,
    loading: false,
    refetch: () => {}, // No-op since data is static
  };
}
